import * as React from 'react';
import spinnerDataURI from './spinnerDataUri';

/**
 * Show a simple spinner loading animation indicator
 * @export
 */
const SpinnerLoader: React.FunctionComponent<{}> = (props) => {

    return (
    <div className="uxp-spinner-loading-block">
        <video src={spinnerDataURI}style={{width: '100%',height: ' 100%'}} loop autoPlay muted />
    </div>
    )
}

export default SpinnerLoader;